import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-light selection:text-white" data-id="element-0" data-mp="2wj8dbo48im46">
      <MetaPixel data-id="element-1" data-mp="28sl3gxardmez" />
      <SocialProofPopup data-id="element-2" data-mp="28s2y9b64bxux" />
      <Hero data-id="element-3" data-mp="23vkzqt1dsvr1" />
      <StatsBar data-id="element-4" data-mp="23w4g45bdvc2y" />
      <TestimonialsSection data-id="element-5" data-mp="23ujk0b9f7l2z" />
      <PainPoints data-id="element-6" data-mp="23t8i6gzjcnei" />
      <ProductSection data-id="element-7" data-mp="3ijxqiu0iq6lh" />
      <BonusSection data-id="element-8" data-mp="3ikh5c1uvgeva" />
      <PricingSection data-id="element-9" data-mp="3ij64oawq3n8e" />

      {/* More Testimonials before Guarantee */}
      <section className="py-12 md:py-20 bg-brand-dark border-t border-gray-800" data-id="element-10" data-mp="3ml12h5fg3ihf">
        <div className="container mx-auto px-4" data-id="element-11" data-mp="3rcj6618urx63">
          <div className="text-center mb-6 md:mb-12" data-id="element-12" data-mp="3rcsy3udgkeef">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-light font-[Poppins,_sans-serif]" data-id="element-13" data-mp="5os92t1uy7l">
              ❤️ LO QUE DICEN LAS QUE YA LO TIENEN
            </h2>
          </div>
          <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-6 max-w-5xl mx-auto" data-id="element-14" data-mp="33movnqc0akp0">
            {[{
            initials: 'MG',
            name: 'Mirta G.',
            location: '📍 Buenos Aires | Sistema Rescate Intestinal +55™',
            quote: '"6 años con panza inflada después de cada comida. A los 10 días me desperté liviana por primera vez en años. Lloré de la emoción."'
          }, {
            initials: 'CS',
            name: 'Carmen S.',
            location: '📍 Córdoba | Sistema Rescate Intestinal +55™',
            quote: '"La Guía de Compras me cambió la vida. Todo lo conseguí en el Coto de mi barrio, sin buscar productos raros ni gastar fortunas."'
          }, {
            initials: 'ER',
            name: 'Elena R.',
            location: '📍 Rosario | Sistema Rescate Intestinal +55™',
            quote: '"El Planner fue lo que me faltaba. Dejé de improvisar, detecté mis detonantes y la panza finalmente respondió."'
          }, {
            initials: 'DF',
            name: 'Diana F.',
            location: '📍 Mendoza | Sistema Rescate Intestinal +55™',
            quote: '"Soy enfermera y empecé con escepticismo. Al día 6 los gases nocturnos bajaron notablemente. Ahora se lo recomiendo a mis pacientes."'
          }].map((t, i) => <div key={i} className="flex flex-col" data-id="element-15" data-mp="18dhqo0l5eu4f" data-mpi={i}>
                <div className="flex items-center gap-3 mb-2" data-id="element-16" data-mp="18bolyqu3ijz2">
                  <div className="w-10 h-10 rounded-full bg-brand-dark border-2 border-brand-green/40 flex items-center justify-center text-brand-light font-bold text-sm shrink-0" data-id="element-17" data-mp="1d59linbc7m0d">
                    {t.initials}
                  </div>
                  <div data-id="element-18" data-mp="13cbwdybuayss">
                    <div className="text-yellow-400 text-sm leading-none mb-0.5" data-id="element-19" data-mp="1r4ir6t1x2xq3">
                      ★★★★★
                    </div>
                    <div className="font-bold text-white text-sm" data-id="element-20" data-mp="1w211onvl1l07">{t.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-21" data-mp="1i4cdp767xxqx">{t.location}</div>
                  </div>
                </div>
                <p className="text-gray-300 italic text-sm leading-relaxed pl-0" data-id="element-22" data-mp="1m3v24cx90qyi">
                  {t.quote}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <Guarantee data-id="element-23" data-mp="arkeekxd3l0x" />
      <FAQ data-id="element-24" data-mp="anwkvlrx2ym7" />
      <CostTable data-id="element-25" data-mp="qx5gbyel6oah" />

      {/* Final CTA Section (Reusing Pricing) */}
      <div className="bg-brand-black border-t border-brand-green/20" data-id="element-26" data-mp="qygk3y817w1l">
        <PricingSection data-id="element-27" data-mp="m5dzifl8fwxj" />
      </div>

      <Footer data-id="element-28" data-mp="m4cat8banbxc" />
    </div>;
}